import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/legal-center/terms-and-conditions`;

export type GetTermsAndConditionsResponse = {
  termsAndConditions: {
    content: string;
    createdAt: string;
    id: number;
    type: 'TERMS_AND_CONDITIONS';
    version: number;
  } | null;
};

export const termsAndConditionsQueryKey = ['user-terms-and-conditions'];

export const getTermsAndConditions = (): Promise<GetTermsAndConditionsResponse> => {
  return axios.get(generateRoutePath(url));
};
type QueryFnType = typeof getTermsAndConditions;

type UseGetTermsAndConditionsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetTermsAndConditions = ({ config }: UseGetTermsAndConditionsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: termsAndConditionsQueryKey,
    queryFn: getTermsAndConditions,
    staleTime: Infinity,
    ...config,
  });
};
